import { generateApiActionTypes } from 'utils/actions/generateActionTypes'
import { ENDPOINTS } from 'utils/api/callApi'
import uuid from 'uuid'
import { IFormState } from './types'

const RATE_TYPES = [
  'all_in',
  'linehaul',
  'dat_estimated_all_in',
  'dat_high_all_in',
  'dat_low_all_in',
  'applied_forward_looking_dat_rate',
  'transfix_cost_prediction_estimate',
  'transfix_cost_prediction_top',
  'transfix_cost_prediction_bottom',
]

const METADATA = [
  'pickup_city',
  'pickup_state_code',
  'pickup_postal_code',
  'delivery_city',
  'delivery_state_code',
  'delivery_postal_code',
  'dat_miles',
]

export const AM_QUOTING_ACTION_TYPES = generateApiActionTypes('AM_QUOTING_TOOL')
export const getShipperSpotRate = (shipment: IFormState) => {
  const {
    additionalStops,
    delivery,
    deliveryStartDate,
    deliveryStartTime,
    equipmentKey,
    externalId,
    isTestQuote,
    pickup,
    pickupStartDate,
    pickupStartTime,
    shipperApplicationId,
    shipperName,
  } = shipment

  const { city: pickupCity, postalCode: pickupPostalCode, state: pickupStateCode } = pickup || {}

  const { city: deliveryCity, postalCode: deliveryPostalCode, state: deliveryStateCode } =
    delivery || {}

  const requestUuid = uuid()
  const formatParams = {
    shipperApplicationId,
    shipperName,
    externalId: externalId || requestUuid,
    pickupStartDate,
    pickupStartTime,
    pickupCity,
    pickupStateCode,
    pickupPostalCode,
    deliveryStartDate,
    deliveryStartTime,
    deliveryCity,
    deliveryStateCode,
    deliveryPostalCode,
    isTestQuote,
    equipmentKey: equipmentKey.value,
    source: 'am_quoting_tool',
    rateTypes: RATE_TYPES,
    metadata: METADATA,
    requestUuid,
    additionalStops,
    numStops: additionalStops.length + 2,
  }

  const requestData = {
    endpoint: ENDPOINTS.shipperSpotRates,
    method: 'POST',
    body: {
      opportunity: formatParams,
    },
  }
  return {
    type: undefined,
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(AM_QUOTING_ACTION_TYPES),
    },
  }
}
